import { useTranslation } from 'react-i18next';

import Header from '@/components/header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import TextTranslationWithDataset from '@/routes/(app)/(tasks)/components/text-translation-with-dataset';
import TextTranslationWithFile from '@/routes/(app)/(tasks)/components/text-translation-with-file';

const TextTranslationTab = {
  WITH_FILE: 'text-translation-with-file',
  WITH_DATASET: 'text-translation-with-dataset',
} as const;

const TextTranslation = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header
        title={t(`tasks.textTranslation.title`)}
        description={t(`tasks.textTranslation.description`)}
      />
      <Tabs defaultValue={TextTranslationTab.WITH_DATASET}>
        <TabsList>
          <TabsTrigger value={TextTranslationTab.WITH_DATASET}>
            {t('tasks.textTranslation.withDataset.title')}
          </TabsTrigger>
          <TabsTrigger value={TextTranslationTab.WITH_FILE}>
            {t('tasks.textTranslation.withFile.title')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value={TextTranslationTab.WITH_DATASET}>
          <TextTranslationWithDataset />
        </TabsContent>
        <TabsContent value={TextTranslationTab.WITH_FILE}>
          <TextTranslationWithFile />
        </TabsContent>
      </Tabs>
    </>
  );
};

export default TextTranslation;
